import Mobile from "./card-technopark-mobile";
import Desktop from "./card-technopark-desktop";

const technopark = {
    Mobile,
    Desktop
}

export default technopark;